import { nonNegativeNumber, positiveNumber, positiveInteger, nonEmptyString } from "@/utils/form";
import { z } from "zod";
import { t } from "i18next";

export const AddCarSchema = z.object({
  name: nonEmptyString(t("modals:addcar.inputs.name.label")),
  netValue: positiveNumber(t("modals:addcar.inputs.netvalue.label")),
  runtime: positiveInteger(t("modals:addcar.inputs.runtime.label")),
  yearlyInsurance: positiveNumber(t("modals:addcar.inputs.yearlyinsurance.label")),
  yearlyTax: positiveNumber(t("modals:addcar.inputs.yearlytax.label")),
  yearlyKilometers: positiveNumber(t("modals:addcar.inputs.yearlykilometers.label")),
  consumption: positiveNumber(t("modals:addcar.inputs.consumption.label")),
  fuelPrice: positiveNumber(t("modals:addcar.inputs.fuelprice.label")),
  repairPerKilometer: positiveNumber(t("modals:addcar.inputs.repairperkm.label")),
  quantity: positiveInteger(t("modals:addcar.inputs.quantity.label")),
  margin: nonNegativeNumber(t("modals:addcar.inputs.margin.label")), // Input as percentage, converted to BPS on submit
});

export const AddCarDefaultValues = {
  name: "",
  netValue: undefined,
  runtime: "" as any, // force reset workaround
  yearlyInsurance: undefined,
  yearlyTax: undefined,
  yearlyKilometers: "" as any, // force reset workaround
  consumption: "" as any, // force reset workaround
  fuelPrice: undefined,
  repairPerKilometer: undefined,
  quantity: "" as any, // force reset workaround
  margin: "" as any, // force reset workaround
};

export type TAddCarSchema = z.infer<typeof AddCarSchema>;
